import { FiChevronDown } from "react-icons/fi";
import { MdOutlineSave, MdOutlineSaveAs } from "react-icons/md";

import Button from "@/components/ui/Button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/shadcn/dropdown-menu";

// The trigger is a plain <button>: ui/Button calls preventDefault on click,
// which stops Radix from ever opening the menu.
export default function AssetsListSaveMenu({
  isSaveDisabled,
  isSaveAsDisabled,
  isBusy,
  onSaveList,
  onSaveListAs,
}) {
  return (
    <div className="AssetsList__saveMenu flex items-stretch">
      <Button
        id="AssetsList__save"
        type="primary"
        size="sm"
        className="rounded-r-none"
        icon={<MdOutlineSaveAs className="w-3.5 h-3.5" />}
        disabled={isSaveDisabled}
        onClick={onSaveList}>
        Save
      </Button>

      <DropdownMenu modal={false}>
        <DropdownMenuTrigger asChild disabled={isBusy}>
          <button
            id="AssetsList__saveMenuTrigger"
            type="button"
            title="More save options"
            className="AssetsList__saveMenuTrigger bg-primary text-primary-foreground border border-l-primary-foreground/20 shadow hover:bg-primary/90 rounded-r-md px-1 flex items-center cursor-pointer disabled:pointer-events-none disabled:opacity-60">
            <FiChevronDown className="w-3 h-3" />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem
            id="AssetsList__saveMenuSave"
            className="AssetsList__saveMenuSave text-xs gap-2"
            disabled={isSaveDisabled}
            onClick={onSaveList}>
            <MdOutlineSaveAs className="w-3.5 h-3.5" />
            Save
          </DropdownMenuItem>
          <DropdownMenuItem
            id="AssetsList__saveAs"
            className="AssetsList__saveAs text-xs gap-2"
            disabled={isSaveAsDisabled}
            onClick={onSaveListAs}>
            <MdOutlineSave className="w-3.5 h-3.5" />
            Save as…
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
